import useCache from "../../../hooks/use-cache";
import useLocalization from "../../../hooks/use-localization";
import { useGetNewsQuery } from '../../../store';
import Separator from "../../shared/Separator";
import { Link } from "react-router-dom";

export default function RecentNews() {

    const localization = useLocalization();

    const cacheKey1 = `news-all-0`;
    const posts = useCache(cacheKey1, useGetNewsQuery, { id: 'all', pageIdentifier: 0 });

    if (!posts?.data?.length) { return; }

    const renderedPosts = posts.data.map(p => {
        const postPath = `/post/${p.id}`;

        return <p key={p.id}>
            <Link to={postPath}>{p.title}</Link>
        </p>
    });

    return (
        <div className="post-widget color-purple">
            <h4 className="text-center">{localization.lastNews}</h4>
            <div>
                <Separator className="color-blue"></Separator>
            </div>
            <div>{renderedPosts}</div>
        </div>
    );
}